exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".n0MZxjtYP_9Y4WtHn6aQe{display:-webkit-box;display:-ms-flexbox;display:flex}._2VkGYfiNorgGFjUGeDZFwp{height:20px;width:20px}", ""]);
// Exports
exports.locals = {
	"option": "n0MZxjtYP_9Y4WtHn6aQe",
	"iconContainer": "_2VkGYfiNorgGFjUGeDZFwp"
};